module.exports = __webpack_public_path__ + "static/media/AccountManagement.da28b2d7.png";